import { ElementRef } from "@angular/core"

export function focusMatInput(elementRef: ElementRef): void {
  setTimeout(() => {
    const editModeElements = elementRef.nativeElement.querySelector("[matInput]")
    if (editModeElements) {
      editModeElements.click()
    }
  })
}
